import React from "react";
import "./glass_project.scss";

import { projectsData } from "./projects-data";

const Glass_Project = () => {
  return (
    <>
      {projectsData.map((project, i) => (
        <div className="glass" key={i}>
          <img src={project.image} alt="" className="glass__image" />
          <div className="glass-content">
            <h3 className="glass-content__title">{project.title}</h3>
            <p className="glass-content__description">{project.description}</p>
            <button className="glass-content__button">
              <a href={project.href} target="_blank" rel="noreferrer">
                See Project
              </a>
            </button>
          </div>
        </div>
      ))}
    </>
  );
};

export default Glass_Project;
